// extracted by mini-css-extract-plugin
module.exports = {"text":"Imprint_text__2dOyQ","title":"Imprint_title__39ooI","wrapper":"Imprint_wrapper__VItCr","privacy":"Imprint_privacy__2-UKh","subtitle":"Imprint_subtitle__2fizh"};